import { Grid, theme } from '@superhi/design'
import styled from 'styled-components'

export const GridCellDesktop = styled(Grid.Cell)`
  display: none;

  @media ${theme.breakpoints.large} {
    display: block;
  }
`
